var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      staticClass: "airport-name",
      attrs: { label: _vm.label, prop: _vm.prop, rules: _vm.rules }
    },
    [
      _c("el-autocomplete", {
        attrs: {
          clearable: true,
          maxlength: 60,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
          "fetch-suggestions": _vm.querySearch,
          "trigger-on-focus": false,
          autofocus: _vm.autofocus
        },
        model: {
          value: _vm.airportName,
          callback: function($$v) {
            _vm.airportName = $$v
          },
          expression: "airportName"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }